import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';

window.globalPosition = {};

function Canvas(props) {
  const canvasRef = React.useRef(null);
  const detailsRef = React.useRef(null);
  const [isDrawing, setIsDrawing] = React.useState(false);
  const [startX, setStartX] = React.useState(0);
  const [startY, setStartY] = React.useState(0);
  const [shapes, setShapes] = React.useState([]);
  const [height, setHeight] = React.useState(0);
  const [width, setWidth] = React.useState(0);
  const highlightClassName = props.selectedTool === 'highlight' ? 'higlighted' : 'non-highlighted';

  React.useEffect(() => {
    const detailsDiv = detailsRef.current;
    const detailsHeight = detailsDiv.getBoundingClientRect().height;
    const detailsWidth = detailsDiv.getBoundingClientRect().width;

    // Set the canvas height dynamically
    setHeight(detailsHeight);
    setWidth(detailsWidth);
  }, [props.selectedTool]);

  React.useEffect(() => {
    const canvas = canvasRef.current;
    const context = canvas.getContext('2d');
    setShapes([]);

    // Remove the text input field if it exists
    const inputs = document.querySelectorAll('input[type="text"]');
    inputs.forEach((input) => {
      input.parentElement.removeChild(input);
    });

    // Clear the canvas
    context.clearRect(0, 0, canvas.width, canvas.height);
  }, [props.selectedQuestionId]);

  React.useEffect(() => {
    if (props.selectedTool === 'erase') {
      const canvas = canvasRef.current;
      const context = canvas.getContext('2d');
      setShapes([]);

      // Remove the text input field if it exists
      const inputs = document.querySelectorAll('input[type="text"]');
      inputs.forEach((input) => {
        input.parentElement.removeChild(input);
      });

      const highlights = document.querySelectorAll('.highlight');
      highlights.forEach((highlight) => {
        const parent = highlight.parentNode;
        while (highlight.firstChild) {
          parent.insertBefore(highlight.firstChild, highlight);
        }
        parent.removeChild(highlight);
      });

      // Clear the canvas
      context.clearRect(0, 0, canvas.width, canvas.height);
    }
  }, [props.selectedTool]);

  function handleMouseDown(event) {
    setIsDrawing(true);
    setStartX(event.nativeEvent.offsetX);
    setStartY(event.nativeEvent.offsetY);

    if (props.selectedTool === 'square') {
      drawSquare(event.nativeEvent.offsetX, event.nativeEvent.offsetY);
    } else if (props.selectedTool === 'circle') {
      drawCircle(event.nativeEvent.offsetX, event.nativeEvent.offsetY);
    } else if (props.selectedTool === 'text') {
      const canvas = canvasRef.current;
      const input = document.createElement('input');
      input.type = 'text';
      input.style.position = 'absolute';
      input.style.zIndex = '99';
      input.style.left = `${event.nativeEvent.offsetX}px`;
      input.style.top = `${event.nativeEvent.offsetY}px`;
      input.style.border = 'none';
      input.style.outline = 'none';
      input.style.background = 'none';
      input.style.font = '30px Arial';
      input.style.color = '#000';

      canvas.parentElement.appendChild(input);
      input.focus();
    } else if (props.selectedTool === 'arrow') {
      drawArrowPointer(startX, startY, event.nativeEvent.offsetX, event.nativeEvent.offsetY);
    } else if (props.selectedTool === 'pen') {
      const canvas = canvasRef.current;
      const ctx = canvas.getContext('2d');
      ctx.beginPath();
      ctx.moveTo(event.nativeEvent.offsetX, event.nativeEvent.offsetY);
    }
    // add other tool drawing functions here
  }

  function handleMouseMove(event) {
    if (isDrawing) {
      const canvas = canvasRef.current;
      const ctx = canvas.getContext('2d');

      if (props.selectedTool === 'pen') {
        const newShape = {
          type: props.selectedTool,
          startX: window.globalPosition.x,
          startY: window.globalPosition.y,
          endX: event.nativeEvent.offsetX,
          endY: event.nativeEvent.offsetY
        };
        setShapes([...shapes, newShape]);
      }

      if (props.selectedTool !== 'pen') {
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        for (const shape of shapes) {
          console.log('shape');
          if (shape.type === 'square') {
            drawSquare(shape.startX, shape.startY, shape.endX, shape.endY);
          } else if (shape.type === 'circle') {
            drawCircle(shape.startX, shape.startY, shape.endX, shape.endY);
          } else if (shape.type === 'arrow') {
            drawArrowPointer(shape.startX, shape.startY, shape.endX, shape.endY);
          } else if (shape.type === 'pen') {
            console.log(shape);
            drowPen(shape.endX, shape.endY, shape.startX, shape.startY);
          }
          // Add logic for other shape types
        }
      }
      if (props.selectedTool === 'square') {
        drawSquare(startX, startY, event.nativeEvent.offsetX, event.nativeEvent.offsetY);
      } else if (props.selectedTool === 'circle') {
        drawCircle(startX, startY, event.nativeEvent.offsetX, event.nativeEvent.offsetY);
      } else if (props.selectedTool === 'text') {
        // Draw text logic here
        const input = document.createElement('input');
        input.type = 'text';
        input.style.position = 'absolute';
        input.style.zIndex = '99';
        input.style.left = `${event.nativeEvent.offsetX}px`;
        input.style.top = `${event.nativeEvent.offsetY}px`;
        input.style.border = 'none';
        input.style.outline = 'none';
        input.style.background = 'none';
        input.style.font = '30px Arial';
        input.style.color = '#000';

        canvas.parentElement.appendChild(input);
        input.focus();
      } else if (props.selectedTool === 'arrow' && startX !== 0 && startY !== 0) {
        drawArrowPointer(startX, startY, event.nativeEvent.offsetX, event.nativeEvent.offsetY);
      } else if (props.selectedTool === 'pen') {
        drowPen(
          event.nativeEvent.offsetX,
          event.nativeEvent.offsetY,
          window.globalPosition.x,
          window.window.globalPosition.y
        );
        window.globalPosition = { x: event.nativeEvent.offsetX, y: event.nativeEvent.offsetY };
      } else if (props.selectedTool === 'erase-content') {
        eraseShape(event.nativeEvent.offsetX, event.nativeEvent.offsetY);
      }
    }
  }

  function drowPen(offsetX, offsetY, prevX, prevY) {
    console.log('drowPen');
    if (prevX !== undefined || prevY !== undefined) {
      console.log(offsetX, offsetY, prevX, prevY);
      const canvas = canvasRef.current;
      const ctx = canvas.getContext('2d');
      ctx.strokeStyle = '#000';

      // Draw a line from the previous position to the current position
      ctx.moveTo(prevX, prevY);
      ctx.lineTo(offsetX, offsetY);
      ctx.stroke();
    }
    // Move to the current position
  }

  function drawSquare(x1, y1, x2, y2) {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    const width = Math.abs(x2 - x1);
    const height = Math.abs(y2 - y1);
    const left = Math.min(x1, x2);
    const top = Math.min(y1, y2);
    ctx.fillStyle = 'rgb(255 255 0 / 47%)';
    ctx.fillRect(left, top, width, height);
    ctx.strokeStyle = '#000';
    ctx.strokeRect(left, top, width, height);
  }

  function drawCircle(x1, y1, x2, y2) {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    const radius = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
    ctx.fillStyle = 'rgb(255 255 0 / 47%)';
    ctx.beginPath();
    ctx.arc(x1, y1, radius, 0, 2 * Math.PI);
    ctx.fill();
    ctx.strokeStyle = '#000';
    ctx.lineWidth = 1;
    ctx.stroke();
  }

  function handleMouseUp(event) {
    setIsDrawing(false);
    setStartX(0);
    setStartY(0);

    if (props.selectedTool !== 'pen') {
      const newShape = {
        type: props.selectedTool,
        startX: startX,
        startY: startY,
        endX: event.nativeEvent.offsetX,
        endY: event.nativeEvent.offsetY
      };
      setShapes([...shapes, newShape]);
    }
    window.globalPosition = {};
  }

  function drawArrowPointer(startX, startY, endX, endY) {
    if (startX === 0 && startY === 0) return;
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    const fromX = startX;
    const fromY = startY;
    const toX = endX;
    const toY = endY;
    const theta = Math.atan2(toY - fromY, toX - fromX);
    const headlen = 20;

    // draw the line
    ctx.beginPath();
    ctx.moveTo(fromX, fromY);
    const arrowX = toX - headlen * Math.cos(theta);
    const arrowY = toY - headlen * Math.sin(theta);
    ctx.lineTo(arrowX, arrowY);

    // draw the arrow head
    ctx.lineTo(
      arrowX - headlen * Math.cos(theta - Math.PI / 6),
      arrowY - headlen * Math.sin(theta - Math.PI / 6)
    );
    ctx.moveTo(arrowX, arrowY);
    ctx.lineTo(
      arrowX - headlen * Math.cos(theta + Math.PI / 6),
      arrowY - headlen * Math.sin(theta + Math.PI / 6)
    );

    ctx.stroke();
    // setArrowPosition({ x: arrowX, y: arrowY });
  }

  function handleHighlightBodyClick() {
    if (props.selectedTool === 'highlight') {
      const selection = window.getSelection();
      const range = selection.getRangeAt(0);
      const newNode = document.createElement('span');
      newNode.classList.add('highlight');
      newNode.style.backgroundColor = 'yellow';
      range.surroundContents(newNode);
    }
  }

  function eraseShape(x, y) {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    const eraserSize = 20; // Adjust the eraser size as needed

    // Check if the mouse is over an input field

    ctx.clearRect(x - eraserSize / 2, y - eraserSize / 2, eraserSize, eraserSize);

    // Remove the erased shape from the shapes state
    const updatedShapes = shapes.filter((shape) => {
      if (shape.type === 'square' || shape.type === 'circle') {
        return !isPointInsideShape(x, y, shape);
      } else if (shape.type === 'arrow') {
        return !isPointOnArrow(x, y, shape);
      } else if (shape.type === 'pen') {
        return !isPointCloseToPen(x, y, shape);
      }
      // Add logic for other shape types if needed
      return true;
    });

    setShapes(updatedShapes);
  }

  function isPointCloseToPen(x, y, shape) {
    const { startX, startY, endX, endY } = shape;
    const penWidth = 5; // Adjust the pen width as needed

    // Calculate the distance between the point and the pen's path
    const dist =
      Math.abs((endX - startX) * (startY - y) - (startX - x) * (endY - startY)) /
      Math.sqrt((endX - startX) ** 2 + (endY - startY) ** 2);

    return dist <= penWidth;
  }

  function isPointInsideShape(x, y, shape) {
    const { startX, startY, endX, endY } = shape;
    const left = Math.min(startX, endX);
    const right = Math.max(startX, endX);
    const top = Math.min(startY, endY);
    const bottom = Math.max(startY, endY);

    return x >= left && x <= right && y >= top && y <= bottom;
  }

  function isPointOnArrow(x, y, shape) {
    const { startX, startY, endX, endY } = shape;
    const dx = endX - startX;
    const dy = endY - startY;
    const arrowLength = Math.sqrt(dx * dx + dy * dy) / 5;
    const arrowWidth = arrowLength / 2;

    // Calculate the distance between the point and the arrow line
    const dist =
      Math.abs((endX - startX) * (startY - y) - (startX - x) * (endY - startY)) /
      Math.sqrt(dx * dx + dy * dy);

    return dist <= arrowWidth;
  }

  return (
    <div style={{ position: 'relative' }}>
      <canvas
        ref={canvasRef}
        width={width - 25}
        height={height}
        className={`${highlightClassName} ${
          props.selectedTool === 'erase-content' ? 'eraser-cursor' : ''
        }`}
        onMouseDown={handleMouseDown}
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
        style={{
          zIndex: 9,
          pointerEvents: `${props.selectedTool == 'highlight' ? 'none' : 'auto'}`,
          position: 'absolute'
        }}
      />

      <div
        onClick={handleHighlightBodyClick}
        ref={detailsRef}
        style={{
          zIndex: 1
        }}>
        {props.Details}
      </div>

      {/* add other tool highlighters here */}
    </div>
  );
}

Canvas.propTypes = {
  selectedTool: PropTypes.string,
  selectedQuestionId: PropTypes.number,
  Details: PropTypes.element
};

export default Canvas;
